import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Login.module.scss";
import { toast } from "react-toastify";
//import admin login api
import loginWithEmail from "../../services/auth/loginWithEmail.js"
import signupUser from "../../services/auth/signupUser.js"
import GoogleLoginButton from "../../components/googleLoginButton/GoogleLoginButton.jsx"
import FacebookLoginButton from "../../components/facebookLoginButton/FacebookLoginButton.jsx";
import AUTH_TOASTS from "../../utils/constants/toastMesages/authToasts.js";
import { STORAGE_KEYS } from "../../utils/constants/storageKeys.js";


/**
 * Login component renders a login form for user authentication.
 *
 * @component
 * @example
 * return (
 *   <Login />
 * )
 */
function Login() {
  //Use navigate hook for navigating to other routes
  const navigate = useNavigate();
  const [step, setStep] = useState(1);

  const fbAppId = process.env.REACT_APP_FACEBOOK_CLIENT_ID;

  //Tracking if create new password is clicked or not 
  const [mode, setMode] = useState("login");
  
  //User credentials object for sending/fetching to backend
  const [credentials, setCredentials] = useState({
    email: "",
    name: "",
    username: "",
    password: "",
  });

  //States for tracking rember me fuctionality
  const [rememberMe, setRememberMe] = useState(false);
  //Login post request
  const handleLogin = async () => {
  try {
    const data = await loginWithEmail(credentials);
    localStorage.setItem(STORAGE_KEYS.TOKEN, data.token);
    localStorage.setItem(STORAGE_KEYS.ROLE, data.user.role);
    toast.success(AUTH_TOASTS.SIGNIN_SUCCESFUL);
    navigate("/billing");
    window.location.reload();
  } catch (error) {
    toast.error(AUTH_TOASTS.SIGNIN_UNSUCCESFUL);
  }
};

//Handler function for signingup the new user 
const handleSignUp = async () => {
  try {
    const data = await signupUser(credentials);
    toast.success(AUTH_TOASTS.REGISTER_SUCCESFUL);
  }
  catch (error) {
    toast.error(AUTH_TOASTS.REGISTER_UNSUCCESFUL);
  }
}

//Helper function for facebook login

  const handleFacebookLogin = () => {
    const clientId = process.env.REACT_APP_FACEBOOK_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_FB_REDIRECT;
    const state = Math.random().toString(36).substring(2);

    // Save state in session for CSRF protection (optional but recommended)
    sessionStorage.setItem("fb_oauth_state", state);

    const authUrl = new URL("https://www.facebook.com/v18.0/dialog/oauth");
    authUrl.searchParams.append("client_id", clientId);
    authUrl.searchParams.append("redirect_uri", redirectUri);
    authUrl.searchParams.append("state", state);
    authUrl.searchParams.append("response_type", "code");
    authUrl.searchParams.append("scope", "email,public_profile");

    // Redirect to Facebook Login
    window.location.href = authUrl.toString();
  };

  const { search, hash } = useLocation();

  useEffect(() => {
    // Combine ?query and #hash so it works in any router mode
    const query = search || hash.replace(/^#/, '?');
    const code  = new URLSearchParams(query).get('code');

    if (!code) return;

    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BASE_API_URL}/auth/facebook`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code })
        });

        if (!res.ok) throw new Error("Backend authentication failed");

        const data = await res.json();

        if (rememberMe) {
          localStorage.setItem("token", data.accessToken);
          localStorage.setItem("role",  data.user.role);
        } else {
          sessionStorage.setItem("token", data.accessToken);
          sessionStorage.setItem("role",  data.user.role);
        }

        toast.success("Login successful");
        window.location.reload();
      } catch (err) {
        console.error(err);
        toast.error("Facebook login failed");
      }
    })();
  }, []);
  return (
    <div className={styles.loginContainer}>
      {/* Left Section - App Download */}
      <div className={styles.appDownloadSection}></div>

      {/* Right Section - Login Form */}
      <div className={styles.loginFormContainer}>
        <div className={styles.formInner}>
          <h1 className={styles.appTitle}>Orderly</h1>

        {/* Login Title */}
        <h2 className={styles.loginTitle}>
          Login
        </h2>
        <div>
          <div></div>
        <div>
        {mode === "login" ? (
          step === 1 ? (
            <>
              {/* Login Step 1 - Email */}
              <p className={styles.inputLabel}>Phone or Email*</p>
              <input
                value={credentials.email}
                onChange={(e) =>
                  setCredentials({ ...credentials, email: e.target.value })
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") setStep(2);
                }}
                type="text"
                className={styles.loginInput}
                placeholder="Enter your phone number or email address"
              />
              {
                !credentials.email && <p className={styles.pleaseEnterDetailsDesign}>Please enter your email*</p>
              }

              <div className={styles.rememberMe}>
                <input type="checkbox" id="remember"  checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)} />
                <label htmlFor="remember">Remember me on this device</label>
              </div>

              <button className={styles.loginButton} onClick={() =>{ credentials.email && setStep(2) }}>
                Login
              </button>

              {/* <button className={styles.createAccountButton} onClick={() => setMode("register")}>
                Create New Account
              </button> */}
            </>
          ) : (
            <>
              {/* Login Step 2 - Password */}
              <p className={styles.inputLabel}>Password</p>
              <div className="d-flex align-items-center gap-3">
                <input
                  value={credentials.password}
                  onChange={(e) =>
                    setCredentials({ ...credentials, password: e.target.value })
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleLogin();
                  }}
                  type="password"
                  className={styles.loginInput}
                  placeholder="Enter your password"
                />
              </div>
              {
                !credentials.password && <p className={styles.pleaseEnterDetailsDesign}>Please enter your password*</p>
              }

              <button className={`${styles.loginButton} ${styles.fullWidth}`} onClick={handleLogin}>
                Login
              </button>
            </>
          )
        ) : (
          <>
            <h3 className="mb-3">Create New Account</h3>
            <p className={styles.inputLabel}>Email*</p>
            <input
              type="email"
              className={styles.loginInput}
              placeholder="Enter your email"
              value={credentials.email}
              onChange={(e) =>
                setCredentials({ ...credentials, email: e.target.value })
              }
            />

            <p className={styles.inputLabel}>Name*</p>
            <input
              type="text"
              className={styles.loginInput}
              placeholder="Enter your name"
              value={credentials.name}
              onChange={(e) =>
                setCredentials({ ...credentials, name: e.target.value })
              }
            />

            <p className={styles.inputLabel}>User Name*</p>
            <input
              type="text"
              className={styles.loginInput}
              placeholder="Enter a your username"
              value={credentials.username}
              onChange={(e) =>
                setCredentials({ ...credentials, username: e.target.value })
              }
            />

            <p className={styles.inputLabel}>Password*</p>
            <input
              type="password"
              className={styles.loginInput}
              placeholder="Enter a strong password"
              value={credentials.password}
              onChange={(e) =>
                setCredentials({ ...credentials, password: e.target.value })
              }
            />

            <button onClick={() => handleSignUp()} className={styles.loginButton}>
              Register
            </button>

            <button className={styles.createAccountButton} onClick={() => {
              setMode("login");
              setStep(1);
            }}>
              Back to Login
            </button>
          </>
        )}
        {/* <GoogleLoginButton rememberMe={rememberMe}/>
        <FacebookLoginButton/> */}
        <div className={styles.divider}></div>
        <div style={{borderRadius:"10px"}}>
    </div>
    </div>
    </div>
          <button className={styles.backLink} onClick={() => window.location.href = process.env.REACT_APP_FRONTEND_URL}>
            Back to {process.env.REACT_APP_NAME}
          </button>
        </div>
        <footer className={styles.footer}>
          Copyright © {new Date().getFullYear()} Ovaku - All rights
          reserved.
        </footer>
      </div>
    </div>
  );
}

export default Login;
